import React from 'react';

import Icon from '@expo/vector-icons/FontAwesome';

import * as _hm from './_hm';
import * as _ht from './_ht';
import * as _cr from './_cr';

import { a } from './_cmABT';

import * as BoxC from './_ccbBoxC';

const $grtAbtz = (pz?: {
  type?: _ht.s,
}) => {
  switch (pz?.type) {
    default:
      return {
        iconPtyz: a('icn/square-o ics/4 icc/lt5'),
        boxStlz: {},
      }
  }
};

export type tIconCz = {
  iconAbtz?: _ht.dz,
  iconPtyz?: _ht.dz,
  boxStlz?: _ht.dz,
};

/*
export const N = React.memo((pz: tIconCz) => {
  const _abtz = $grtAbtz(pz.iconAbtz)
  return (
    _cr.c(Icon, {
      ... _abtz.iconPtyz,
      ... pz.iconPtyz,
    })
  );
});

export const B = React.memo((pz: tIconCz) => {
  const _abtz = $grtAbtz(pz.iconAbtz)
  return (
    _cr.c(BoxC.N, {
      boxStlz: {
        ... _abtz.boxStlz,
        ... pz.boxStlz,
      },
      boxClds: [
        _cr.c(N, {
          iconPtyz: {
            ... _abtz.iconPtyz,
            ... pz.iconPtyz,
          },
        })
      ]
    })
  )
});
*/

export const N = React.memo((pz: tIconCz) => {
  const _abtz = $grtAbtz(pz.iconAbtz)
  let _o = (
    _cr.c(Icon, {
      ... _abtz.iconPtyz,
      ... pz.iconPtyz,
    })
  );
  if ( _hm.f(pz.boxStlz) || _hm.f(_abtz.boxStlz) ) {
    _o = (
      _cr.c(BoxC.N, {
        boxStlz: {
          ... _abtz.boxStlz,
          ... pz.boxStlz,
        },
        boxClds: _o
      })
    );
  }
  return _o;
});
